import AdminSidebar from '../components/admin/AdminSidebar';
import AdminHeader from '../components/admin/AdminHeader';
import AdminModelsComponent from '../components/admin/AdminModels';
import '../styles/admin.css';

export default function AdminModels() {
  return (
    <div className="admin-layout">
      <AdminSidebar />
      <div className="admin-content">
        <AdminHeader 
          title="Gestion des Modèles" 
          subtitle="Créez et gérez vos modèles de sites ici"
        />
        <AdminModelsComponent />
      </div>
    </div>
  );
}